// ── Native app store listings ────────────────────────────────────────────────
// One place for the links, so the website badges, the /app redirect, the iOS
// Smart App Banner (public/index.html) and the web manifest stay in step.

export const APP_STORE_ID = '6807249514';
export const PLAY_PACKAGE = 'com.dreamybedtime.twa';

// No country segment: apps.apple.com sends each visitor to their own
// storefront, where a /us/ link would show the US page (US prices) to everyone.
export const APP_STORE_URL = `https://apps.apple.com/app/dreamy-bedtime/id${APP_STORE_ID}`;

// The referrer carries UTM tags into Play Console's acquisition reports, so
// installs can be traced back to the website and to which badge was tapped.
export const playStoreUrl = (placement = 'website') =>
  `https://play.google.com/store/apps/details?id=${PLAY_PACKAGE}&referrer=${encodeURIComponent(
    `utm_source=dreamybedtime.com&utm_medium=website&utm_campaign=${placement}`
  )}`;

const ua = () => (typeof navigator === 'undefined' ? '' : navigator.userAgent || '');

// Search-engine crawlers present as phones (Googlebot's smartphone agent says
// "Android"), and must never be redirected off a page they are indexing.
export const isBot = () => /bot|crawler|spider|crawling|slurp|lighthouse|headless/i.test(ua());

/** 'ios' | 'android' | null — which store this device installs from. */
export const deviceStore = () => {
  const s = ua();
  if (/android/i.test(s)) return 'android';
  if (/iphone|ipad|ipod/i.test(s)) return 'ios';
  // iPadOS Safari reports itself as a Mac; only the touch screen gives it away.
  if (/macintosh/i.test(s) && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1) return 'ios';
  return null;
};
